// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:13:19

export default {
  "id": "sprunki-clicker-and-merge-phase-3",
  "slug": "sprunki-clicker-and-merge-phase-3",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/991a29b2d32f4bd3977e214bd8aca891-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/991a29b2d32f4bd3977e214bd8aca891/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "sprunki clicker & merge phase 3",
      "description": "Sprunki Clicker & Merge: Phase 3 is an exciting rhythm-based idle game where you tap to earn money and unlock new Sprunki creatures! Each Sprunki has a unique musical beat, and as you merge them, you create richer, more dynamic melodies. Grow your collection, upgrade your beats, and become the ultimate Sprunki maestro!",
      "instructions": "? Click to Earn: Tap along with the beat to generate coins and unlock new Sprunkis. The better your timing, the bigger your rewards!\n? Merge & Upgrade: Combine two identical Sprunkis to evolve them into a stronger, more musical version, enhancing your soundscape and earnings.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "clicker",
        "music"
      ]
    },
    "zh-CN": {
      "title": "斯普兰基点击器 & 合并阶段3",
      "description": "Sprunki Clicker & Merge: 第3阶段是一款激动人心的节奏型休闲游戏，通过点击赚取金钱并解锁新的Sprunki生物！每个Sprunki都有独特的音乐节奏，当你将它们合并时，你会创造出更丰富、更有活力的旋律。扩充你的收藏，升级你的节奏，成为终极Sprunki大师！",
      "instructions": "? 点击赚钱：跟随节奏点击，生成硬币并解锁新的Sprunkis。你的时机越好，奖励越大！\n? 合并升级：合并两个相同的Sprunkis，将其进化成更强大、更有音乐感的版本，增强你的音景和收入。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "点击器",
        "音乐"
      ]
    },
    "zh-TW": {
      "title": "Sprunki Clicker & Merge 阶段3",
      "description": "Sprunki Clicker & Merge: 第3階段是一款令人興奮的節奏基礎閒置遊戲，透過點擊來賺取金錢並解鎖新的Sprunki生物！每個Sprunki都有獨特的音樂節奏，當你將它們合併時，就能創造出更豐富、更具動感的旋律。擴大你的收藏，升級你的節奏，成為最終的Sprunki大師！",
      "instructions": "? 點擊獲利：隨著節奏點擊，生成幣幣並解鎖新Sprunkis。你的時間掌握得越好，獎勵就越大！\n? 合並與升級：合並兩個相同的Sprunkis，讓它們進化成更強大、更具音樂感的版本，提升你的聲音風景和收入。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "點擊器",
        "音樂"
      ]
    },
    "zh-HK": {
      "title": "Sprunki Clicker & 合並階段 3",
      "description": "Sprunki Clicker & Merge: 第3階段是一款令人興奮的節奏基礎閒置遊戲，透過點擊賺取金錢並解鎖新Sprunki生物！每個Sprunki都有獨特的音樂節奏，當你將它們合併時，你將創造出更豐富、更具動感的旋律。增長你的收藏，升級你的節奏，成為最終的Sprunki大師！",
      "instructions": "? 點擊賺錢：跟隨節奏點擊，生成金幣並解鎖新Sprunkis。你的時間掌握得越好，獎勵就越大！\n? 合並及升級：將兩個相同的Sprunkis合並，進化成更強大、更具音樂感的版本，提升你的音景和收入。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "點擊器",
        "音樂"
      ]
    },
    "ja": {
      "title": "スプリンキー・クリッカーアンド・マージ・フェーズ3",
      "description": "Sprunki Clicker & Merge: フェーズ3は、タップでお金を稼ぎ、新しいSprunki生物を解禁する興味深いリズムベースのインディー游戏です！各Sprunkiにはユニークな音楽のリズムがあり、それらを合体させるとより豊かでダイナミックなメロディが作られます。コレクションを育て、リズムをアップグレードし、究極のSprunkiマエストロになる吧！",
      "instructions": "? クリックして稼ぐ：リズムに合わせてタップしてコインを生成し、新しいSprunkisを解放。タイミングが良ければ、もっと大きな報酬がもらえる！\n? 合成とアップグレード：同じSprunkisを2つ組み合わせて、より強くて音楽的なバージョンに進化させ、サウンドシーンと収益を向上させる。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "クリッカーソング"
      ]
    },
    "ko": {
      "title": "스프빈키 클릭어 & 메이지 파이즈 3",
      "description": "스프런키 클리커 & 메이지: 파이즈 3는 탭으로 돈을 벌고 새로운 스프런키 생물을 해금하는 흥미진진한 리듬 기반 비디오 게임입니다! 각 스프런키는 독특한 음악 비트를 가지고 있으며, 합쳐서 더 풍부하고 역동적인 멜로디를 만듭니다. 콜렉션을 키우고 비트를 업그레이드하여 최종 스프런키 마에스트로가 되세요!",
      "instructions": "? 클릭하여 벌기: 비트에 맞춰 탭하여 코인을 생성하고 새로운 스프런키스를 해금하세요. 타이밍이 좋을수록 보상이 커집니다!\n? 합성 및 업그레이드: 같은 스프런키스 두 개를 결합하여 더 강력하고 음악적인 버전으로 진화시키고, 사운드스케이프와 수익을 향상시켜주세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "클릭러",
        "음악"
      ]
    },
    "fr": {
      "title": "Sprunki Clicker & Merge Phase 3",
      "description": "Sprunki Clicker & Merge: Phase 3 est un jeu d'idle basé sur le rythme passionnant où vous appuyez pour gagner de l'argent et déverrouiller de nouveaux créatures Sprunki ! Chaque Sprunki a un battement musical unique, et au fur et à mesure que vous les fusionnez, vous créez des mélodies plus riches et plus dynamiques. Élevez votre collection, mettez à jour vos battements, et devenez le maître ultime des Sprunki !",
      "instructions": "? Gagnez en cliquant : appuyez en synchronisation avec le rythme pour générer des pièces et débloquer de nouveaux Sprunkis. Plus votre timing est bon, plus les récompenses sont importantes !\n? Fusionner et Niveau supérieur : combinez deux Sprunkis identiques pour les évoluer en une version plus forte et plus musicale, améliorant votre ambiance sonore et vos gains.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "cliqueur",
        "musique"
      ]
    }
  }
};
